import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M12.23 2.271a1.25 1.25 0 0 0-.46 0 1.65 1.65 0 0 0-.435.164l-.028.014L1.665 7.27a.75.75 0 0 0 0 1.342L4.363 9.96l-2.69 1.305a.75.75 0 0 0-.008 1.346l9.642 4.82.027.015c.098.049.258.13.436.163.152.03.308.03.46 0 .179-.033.339-.114.436-.163l.027-.014 9.643-4.821a.75.75 0 0 0-.008-1.346l-2.69-1.305 2.698-1.35a.75.75 0 0 0 0-1.34l-9.643-4.822-.027-.014a1.65 1.65 0 0 0-.435-.164ZM12 3.78l8.323 4.161L12 12.102 3.677 7.941 12 3.78Z",
  "clip-rule": "evenodd"
}, null, -1), a = /* @__PURE__ */ e("path", { d: "M2.336 15.27a.75.75 0 1 0-.671 1.342l9.642 4.82.027.015c.098.049.258.13.436.163.152.03.308.03.46 0 .179-.033.339-.114.436-.163l.027-.014 9.643-4.821a.75.75 0 1 0-.671-1.342L12 20.102 2.336 15.27Z" }, null, -1), c = [
  n,
  a
];
function r(d, s) {
  return l(), t("svg", o, [...c]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
